import {Stack, useTheme} from '@mui/material';
import Box from '@mui/material/Box';
import clsx from 'clsx';
import React, {useContext} from 'react';
import {useSelector} from 'react-redux';
import {AppState} from 'shared/store';
import AppContext from '../../../@crema/utility/AppContext';
import {LayoutType, ThemeStyle} from '../../configs/AppEnums';
import AppContextPropsType from '../../models/AppContextPropsType';
import InfoView from '../InfoView';
import AppFixedFooter from './AppFixedFooter';
import AppHeader from './AppHeader';
import useStyles from './AppLayout.style';
import ContentView from './ContentView';
import SnackbarItem from './SnackbarItem';

interface AppLayoutProps {
  props?: any;
}

const AppLayout: React.FC<AppLayoutProps> = (props) => {
  const {footer, layoutType, footerType, themeStyle} = useContext<AppContextPropsType>(AppContext);
  const classes = useStyles();
  const theme = useTheme();
  const {alerts} = useSelector<AppState, AppState['common']>((state) => state.common);
  const scrollbarHeight = themeStyle === ThemeStyle.MODERN ? 'calc(100vh - 260px)' : 'calc(100vh - 198px)';
  const scrollbarHeightXl = themeStyle === ThemeStyle.MODERN ? 'calc(100vh - 300px)' : 'calc(100vh - 236px)';

  return (
    <Box
      className={clsx(classes.appMain, layoutType === LayoutType.BOXED ? classes.boxedLayout : '', {
        appMainFooter: footer && footerType === 'fluid',
        appMainFixedFooter: footer && footerType === 'fixed',
      })}
      sx={{
        // Surcharge via sx pour les valeurs dynamiques
        '&.appMainFixedFooter .scrollAppSidebar': {
          height: `${scrollbarHeight} !important`,
        },
        [`@media (min-width: ${theme.breakpoints.values.xl}px)`]: {
          '&.appMainFixedFooter .scrollAppSidebar': {
            height: `${scrollbarHeightXl} !important`,
          },
        },
      }}>
      <AppHeader />

      <Box className={classes.mainContent}>
        <Box className={classes.mainContainerFull}>
          <Stack spacing={1} sx={{position: 'fixed', top: 24, right: 25, zIndex: 1400}}>
            {alerts && alerts.map((alert) => <SnackbarItem key={alert.id} notif={alert} />)}
          </Stack>
          <ContentView>{props.children}</ContentView>
          <InfoView />
          <AppFixedFooter />
        </Box>
      </Box>
    </Box>
  );
};

export default AppLayout;
